export default "__VITE_ASSET__3s79rpzq__"